/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React, {useState} from "react";

// You can delete this file if you're not using it
import 'semantic-ui-css/semantic.min.css'
import "./src/css/responsive.css";

import CartContext from "./src/contexts/CartContext"

// From https://www.gatsbyjs.org/blog/2019-01-31-using-react-context-api-with-gatsby/
let Cart = props => {
  const [cart, setCart] = useState([]);

  return <CartContext.Provider value={ {cart, setCart} }>
    {props.children}
  </CartContext.Provider>
}

export const wrapRootElement = ({ element }) => (
  <Cart>{element}</Cart>
)

